import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrTransposedGrid from "@grapecity/wijmo.react.grid.transposed"

import { useEffect, useRef } from "react"
import CONSTANT from "../../../constant"
import { T部所売上額 } from "../../../service/dashboard/TDashboard"
import { create部所売上集計 } from "./BusyoUriagegaku"

export const BusyoUriagegakuGrid: React.FC<{
  busyoUriageGakuList: T部所売上額[] | null | undefined
  busyoCode: string | undefined | null
}> = (props) => {
  const gridRef = useRef<wjrGrid.FlexGrid>(null)

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.busyoUriageGakuList == null
    )
      return
    const grid = gridRef.current.control as wjcGrid.FlexGrid

    grid.itemsSource = [
      create部所売上集計(props.busyoUriageGakuList, props.busyoCode),
    ]
  }, [props.busyoUriageGakuList, props.busyoCode])

  return (
    <>
      <wjrTransposedGrid.TransposedGrid
        className="w-17rem"
        {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        headersVisibility={wjcGrid.HeadersVisibility.Row}
        ref={gridRef}>
        <wjrTransposedGrid.TransposedGridRow
          binding={"予算額"}
          header={"当月売上予算"}></wjrTransposedGrid.TransposedGridRow>
        <wjrTransposedGrid.TransposedGridRow
          binding={"当年実績"}
          header={"当月売上実績"}></wjrTransposedGrid.TransposedGridRow>
        <wjrTransposedGrid.TransposedGridRow
          binding={"乗務員売上"}
          header={"当月乗務員売上"}></wjrTransposedGrid.TransposedGridRow>
        <wjrTransposedGrid.TransposedGridRow
          format={"p"}
          binding={"達成率"}
          header={"達成率"}></wjrTransposedGrid.TransposedGridRow>
        <wjrTransposedGrid.TransposedGridRow
          binding={"前年実績"}
          header={"前年同月実績"}></wjrTransposedGrid.TransposedGridRow>
        <wjrTransposedGrid.TransposedGridRow
          format={"p"}
          binding={"前年比"}></wjrTransposedGrid.TransposedGridRow>
      </wjrTransposedGrid.TransposedGrid>
    </>
  )
}
